import React from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import { BiCollapse, BiExpand } from "react-icons/bi";
import { arrowRotateCwIcon as refreshIcon } from "@progress/kendo-svg-icons";
import { SvgIcon } from "@progress/kendo-react-common";
import { RxCross2 } from "react-icons/rx";
import { MdCheckCircle } from "react-icons/md";
import { HiOutlineDocumentText } from "react-icons/hi2";
import logo from "../../../assets/Logos/linqlawhublogo.svg";
import styles from "./DocumentViewer.module.scss";

export const ErrorMessage = () => (
  <div className="d-flex align-items-center justify-content-center h-100 w-100">
    <div className="text-center">
      <p className="text-danger">Document is not available or has been deleted.</p>
      <p className="text-muted">
        Please try refreshing or contact support if the issue persists.
      </p>
    </div>
  </div>
);

export const IconBackground = (props) => {
  return (
    <div
      className={`${props.className} ${styles["icon-background"]} cursor-pointer`}
      title={props.title}
      onClick={() => {
        if (props.onClick) props.onClick();
      }}>
      {props.children}
    </div>
  );
};

export const VersionCard = ({
  version,
  isLatest,
  changeVersion,
  collapsedVersion,
  currentVersion,
  index,
}) => {
  const formattedDate = new Date(version.dateModified).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  return (
    <div
      onClick={() => changeVersion(version)}
      className={`${styles.cardContainer} ${
        !isLatest && "mt-2"
      } d-flex gap-2 cursor-pointer justify-content-between align-items-center ${
        currentVersion === index
          ? styles["version-card-active"]
          : styles["version-card-inactive"]
      }`}>
      {collapsedVersion ? (
        <div className={`${styles.versionInfo} mt-2`}>
          <div className={styles.versionTitle}>V - {version.versionNo}</div>
        </div>
      ) : (
        <div className={styles.versionInfo}>
          <div className="d-flex align-items-center justify-content-between w-100 gap-4">
            <div className={styles.versionTitle}>Version {version.versionNo}</div>
            {isLatest && (
              <div className={`${styles.currentLabel} ms-1 px-2 mb-2`}>
                <MdCheckCircle className={styles.currentIcon} />
              </div>
            )}
          </div>
          <div className={styles.dateContainer}>
            <FaRegCalendarAlt color="gray" />
            <span className={styles.dateText}>{formattedDate}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export const DialogTitleBarContent = ({
  titleText,
  isStandalone,
  matterRef,
  isEmpty,
  onClose,
  fullScreen,
  setFullScreen,
  handleDocumentRefresh,
  styles: componentStyles,
}) => {
  return (
    <div className="w-100 d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center">
        {isStandalone && (
          <>
            <img
              src={logo}
              alt="Linq Law Hub"
              className={componentStyles["dialog-logo"]}
            />

            <div className={`ms-2 me-3 ${componentStyles["vertical-border"]}`}></div>
          </>
        )}
        <div className="d-flex align-items-center">
          <div>{titleText}</div>
          {isStandalone && matterRef && (
            <div className={`ms-3 px-3 py-1 rounded bgsecondary rounded-pill fs-md`}>
              Matter: <span className="fw-bold ps-1">{matterRef}</span>
            </div>
          )}
        </div>
      </div>
      <div className="d-flex align-items-center">
        {!isEmpty && (
          <>
            <IconBackground onClick={handleDocumentRefresh}>
              <SvgIcon icon={refreshIcon} style={{ width: 17, height: 17 }} />
            </IconBackground>
            {!isStandalone && (
              <hr className={`${componentStyles["vertical-border"]} ms-3 me-3`} />
            )}
          </>
        )}
        {!isStandalone && (
          <IconBackground onClick={() => setFullScreen(!fullScreen)}>
            {fullScreen ? (
              <BiCollapse size={20} role="button" />
            ) : (
              <BiExpand size={20} role="button" />
            )}
          </IconBackground>
        )}

        <hr className={`${componentStyles["vertical-border"]} ms-3 me-3`} />
        <IconBackground onClick={onClose} className="me-2">
          <RxCross2 size={20} color="red" role="button" />
        </IconBackground>
      </div>
    </div>
  );
};

export const EmptyDocument = () => {
  return (
    <div className="h-100 d-flex align-items-center justify-content-center">
      <div className="text-center">
        <div
          className="mb-3"
          style={{
            opacity: 0.3,
          }}>
          <HiOutlineDocumentText size={60} />
        </div>
        <div
          className="fs-5"
          style={{
            color: "#707070",
          }}>
          No document attached
        </div>
        <div className="fs-md mt-1" style={{ color: "#999" }}>
          Select an activity with a document to view
        </div>
      </div>
    </div>
  );
};
